<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar :background-color="sidebarBackground" short-title="TH" title="Tillered Hub" homeLink="/home">
      <template slot="links">
        <sidebar-item :link="{
          name: $t('sidebar.dashboard'),
          icon: 'tim-icons icon-chart-pie-36',
          path: '/home/dashboard'
        }" :active="storeUserProfile.hasCompany()">
        </sidebar-item>
        <sidebar-item :link="{
          name: $t('sidebar.nodes'),
          icon: 'tim-icons icon-tv-2',
          path: '/home/nodes'
        }">
        </sidebar-item>
        <sidebar-item :link="{
          name: $t('sidebar.networks'),
          icon: 'tim-icons icon-vector',
          path: '/home/networks'
        }">
        </sidebar-item>
        <sidebar-item :link="{
          name: $t('sidebar.organisation'),
          icon: 'tim-icons icon-molecule-40',
          path: '/home/organisations/all'
        }">
        </sidebar-item>
        <sidebar-item :link="{
          name: $t('sidebar.profile'),
          icon: 'tim-icons icon-badge',
          path: '/home/profile'
        }">
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>
      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './SampleNavbar.vue';
import ContentFooter from './SampleFooter.vue';
import SidebarFixedToggleButton from './SidebarFixedToggleButton.vue';
import { ZoomCenterTransition } from 'vue2-transitions';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    ZoomCenterTransition
  },
  data() {
    return {
      sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        initScrollbar('main-panel');
        initScrollbar('sidebar-wrapper');

        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
      //console.log('init scrollbar')
      //console.log(this.$store.getters.userProfile.company.name != "unspecified")
    },
  },
  computed: {
    storeState() {
      return this.$store.state;
    },
    storeUsers() {
      return this.$store.state.users;
    },
    storeUserProfile() {
      return this.storeUsers.userProfile;
    },
  },
  mounted() {
    const vm = this;
    vm.initScrollbar();
    this.$sidebar.toggleMinimize();

    // Clean the Open Modal
    document.body.classList.remove('modal-open');
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
